<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.4 0C2.6268 0 2 0.626801 2 1.4V14.6C2 15.3732 2.6268 16 3.4 16H12.6C13.3732 16 14 15.3732 14 14.6V1.4C14 0.626801 13.3732 0 12.6 0H3.4ZM6.1 3.8C5.76863 3.8 5.5 4.06863 5.5 4.4V4.8C5.5 5.13137 5.76863 5.4 6.1 5.4H9.9C10.2314 5.4 10.5 5.13137 10.5 4.8V4.4C10.5 4.06863 10.2314 3.8 9.9 3.8H6.1ZM4 7.4C4 7.06863 4.26863 6.8 4.6 6.8H11.4C11.7314 6.8 12 7.06863 12 7.4V7.8C12 8.13137 11.7314 8.4 11.4 8.4H4.6C4.26863 8.4 4 8.13137 4 7.8V7.4ZM4.6 9.8C4.26863 9.8 4 10.0686 4 10.4V10.8C4 11.1314 4.26863 11.4 4.6 11.4H11.4C11.7314 11.4 12 11.1314 12 10.8V10.4C12 10.0686 11.7314 9.8 11.4 9.8H4.6Z"
  />
</template>
